import React, { Component } from "react";
import "./stylesheets/headerback.css";
import constant from "../../../configs/constant";
import Auth from "../../../modules/Auth";
import { Navbar, Nav, Container, NavItem } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import { FaHome } from "react-icons/fa";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { Modal } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import { CgNotes } from "react-icons/cg";

export default class HeaderBack extends Component {
  constructor(props) {
    super(props);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);

    const display_name = decoded.display_name;

    var currentPath = window.location.pathname;
    this.state = {
      scope: "Services",
      headerapp: "Approvals",
      display_name: display_name,
      currentPath: currentPath,
      showClass: false,
      showSplash: false,
      tantedList: [],
    };
  }

  componentDidMount() {
    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    var userpermisson = decoded.user_permissions;

    var ApplicationPermissions = userpermisson[0].ApplicationPermissions;
    // const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = ApplicationPermissions?.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      if (filteredData[0].PermissionCode === "VALIDATE_JOB") {
        this.setState({
          headerapp: "Validate",
        });
      } else if (filteredData[0].PermissionCode === "AUTHORIZE_JOB") {
        this.setState({
          headerapp: "Approvals",
        });
      }
    } else {
    }
    window.scrollTo(0, 0);
    // Check if the splash modal should be shown here
    const splashShowed = localStorage.getItem("splashShowed");
    if (!splashShowed || splashShowed === "false") {
      this.checkSplashScreen();
    }
  }

  checkSplashScreen = () => {
    const lastSplashDate = localStorage.getItem("last_splash_date");
    const today = new Date();
    if (!lastSplashDate) {
      localStorage.setItem("last_splash_date", today);
    }
    const lastSplashDateSaved = new Date(
      localStorage.getItem("last_splash_date")
    );

    if (today.getDate() - lastSplashDateSaved.getDate() > 2) {
      this.setState({ showSplash: false });
    } else {
      this.setState({ showSplash: true });
    }
  };

  handleInNewTab = (event) => {
    var url =
      "https://thejoengineering-my.sharepoint.com/:b:/g/personal/itcorp_thejo-engg_com/Eade7YbgjDhAhcHIgT2FPgYB3dbAZohmTEqgXqdwqrV8sQ?e=amL3Lo";
    console.log();
    window.open(url, "_blank", "noopener,noreferrer");
  };

  handleChange = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        Auth.logout();
      }
    });
  };

  handleCloseSplash = (event) => {
    this.setState({
      showSplash: false,
    });
    localStorage.setItem("splashShowed", "true");
  };

  handleShowData = (event) => {
    const accesstokendata = localStorage.getItem("user_tenant");
    const readData = JSON.parse(accesstokendata);
    var tantedList = readData;
    this.setState({
      tantedList: tantedList,
      showClass: true,
      showSplash: false,
    });
  };

  handleClose = (event) => {
    this.setState({
      showClass: false,
    });
  };

  handleTenant = (event) => {
    var selected_tenant = {
      ApplicationTenantID: event.ApplicationTenantID,
      Tenant: event.Tenant,
    };
    localStorage.setItem("selected_tenant", JSON.stringify(selected_tenant));
    window.location.reload();
    this.setState({
      showClass: false,
    });
  };

  handleOpenInNewWindow = () => {
    window.open("/release-note", "_blank");
  };

  handleInNewTab = (event) => {
    var url = require("../../../assets/images/BG User Manual_V1.0 1.pdf");
    window.open(url, "_blank", "noopener,noreferrer");
  };

  render() {
    const logocompany = require("../../../assets/images/Thejo Splice logofive.png");
    const bgSplashPageImg = require("../../../assets/images/bgSplashPageImg.jpg");
    const homeLogo = require("../../../assets/images/home2.png");
    const homeBlueLogo = require("../../../assets/images/homeblue.png");
    const logoutLogo = require("../../../assets/images/logout.png");
    // const switchLogo = require('../../../assets/images/2374111-200.png');
    var tantedList = this.state.tantedList;
    return (
      <header className="header-back container">
        <Navbar bg="light" className="back-nav">
          <Navbar.Brand href="#home">
            <NavLink className="nav-link text-end" to="/home">
              <img src={logocompany} alt="logo" className="logo-header-back" />
            </NavLink>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="navData">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu nav-link font_size"
                    : "nav-link nav-link-data font_size"
                }
                to="/home"
                title="Home"
              >
                <FaHome className="homeIconClass" />
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "active-menu nav-link font_size"
                    : "nav-link nav-link-data font_size"
                }
                to="/summary"
                title="Summary"
              >
                Summary
              </NavLink>
              {/* <NavLink  className={({ isActive }) => (isActive ? "active-menu nav-link font_size" : "nav-link nav-link-data font_size")} to='/master'>Masters</NavLink>
                <NavLink  className={({ isActive }) => (isActive ? "active-menu nav-link font_size" : "nav-link nav-link-data font_size")} to='/mapping'>Mapping</NavLink>
                <NavLink  className={({ isActive }) => (isActive ? "active-menu nav-link font_size" : "nav-link nav-link-data font_size")} to='/transactions'>Users</NavLink>
                <NavLink  className={({ isActive }) => (isActive ? "active-menu nav-link font_size" : "nav-link nav-link-data font_size")} to='/transactions'>Customers</NavLink> */}
              {/* <NavItem className="nav-link cursorClass font_size" onClick={this.handleInNewTab}><img src={helpLogo}
                             alt="logo" className="logo-header-help"/></NavItem> */}
              <NavItem
                className="nav-link cursorClass font_size"
                onClick={this.handleInNewTab}
              >
                <AiOutlineQuestionCircle className="homeIconClass" />
              </NavItem>
            </Nav>
            <Nav className="me-auto2">
              <span className="diplay_name ml-auto">
                {this.state.display_name}
              </span>
              <span className="header_name_data">
                <b>𝓑𝓖</b>
              </span>
              <span className="verClassother">{constant.appVersions}</span>{" "}
              <NavItem
                className="nav-link cursorClass font_size "
                // to="/release-note"
                onClick={this.handleOpenInNewWindow}
                title="Release Note"
              >
                <CgNotes className="homeIconClass color-white" color="white" />
              </NavItem>
              <NavItem
                className="nav-link cursorClass font_size"
                onClick={this.handleChange}
                title="Logout"
              >
                <RiLogoutBoxRLine className="homeIconClass" />
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Modal
          show={this.state.showClass}
          backdrop="static"
          onHide={this.state.handleClose}
        >
          <Modal.Header>
            <Modal.Title>Select</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modelBody">
            {tantedList.length > 0
              ? tantedList.map((item, indexdata) => {
                  return (
                    <p
                      className="tenantClass"
                      onClick={(event) => this.handleTenant(item)}
                    >
                      {item.Tenant}
                    </p>
                  );
                })
              : ""}
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showSplash}
          backdrop="static"
          className=" d-flex align-items-center justify-content-center "
          onHide={() => this.setState({ showSplash: false })}
        >
          <Modal.Body className="modelBody modal-bg-img">
            <span onClick={this.handleCloseSplash} className="cross-btn">
              x
            </span>
            <div className="d-flex">
              <div>
                <img src={bgSplashPageImg} className="bgimage-modal" />
              </div>
              <div className="mt-2 p-4">
                <div>
                  {" "}
                  <img
                    src={logocompany}
                    alt="logo"
                    className="logo-header-back logo-size"
                  />
                </div>
                <h2 className="update-heading mt-2"> New Feature Update !! </h2>
                <div className="update-para mt-2">
                  Please refer to Release Note <CgNotes /> attached for details.
                </div>
                {/* <div className="update-para">is now online...</div> */}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    );
  }
}
